import { render } from "./VacacionesPage.vue?vue&type=template&id=5a67bdb2"
import script from "./VacacionesPage.vue?vue&type=script&lang=js"
export * from "./VacacionesPage.vue?vue&type=script&lang=js"

import "./VacacionesPage.vue?vue&type=style&index=0&id=5a67bdb2&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__